<template>
  <div class="sidebar-container" :class="{'is-active':isCollapse}">
    <div class="home_shousuo" @click="showCollapse">
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="isCollapse?'#icon-home_shousuo_h_icon':'#icon-home_shousuo_icon'"></use>
      </svg>
    </div>
      <div class="out-menu">
        <div class="inner-menu">
          <el-menu unique-opened = "true"
            :default-active="nowTagValue"
            mode="vertical"
            class="el-menu-vertical-demo el-menu-ciicshared"
            text-color="#000"
            active-text-color="#0d4d80"
            :collapse="isCollapse"
            :default-openeds="opened"
          >
            <sidebar-item :menuData="menu" :isCollapse="isCollapse"></sidebar-item>
          </el-menu>
        </div>
      </div>
  </div>
</template>

<script>
import {setUrlPath} from '@/util/util';
import {mapGetters} from 'vuex';
import SidebarItem from './sidebarItem';
import ciicsharedMenus from "@/menus/ciicshared/ciicshared";
import homeMenus from '@/menus/home/home';
import {deepCopy, getAuthorizedMenu} from '@/util/util';
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'

export default {
  name: 'sidebar-ciicshared',
  components: {SidebarItem},
  data() {
    return {
      screenWidth: document.body.clientWidth, // 屏幕宽度
      localMenu: [],
    };
  },
  created() {
    this.isLocal = process.env.VUE_APP_LOCAL_DEVELOPMENT
    if (this.screenWidth <= 1400) {
      this.$store.commit('SET_COLLAPSE');
    }
    let newMenusArray = ciicsharedMenus;
    this.localMenu = newMenusArray;
    this.$store.commit('SET_MENU', newMenusArray);
  },
  computed: {
    ...mapGetters(['isCollapse', 'pms', 'menu', 'opened', 'memberInfo', 'accessToken', 'cusLogo']),
    nowTagValue() {
      return setUrlPath(this.$route);
    }
  },
  methods: {
    showCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    initWebSocket() {
      this.connection();
      let that = this;
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      // this.timer = setInterval(() => {
      //   try {
      //     that.stompClient.send("test");
      //   } catch (err) {
      //     console.log("断线了: " + err);
      //     that.connection();
      //   }
      // }, 5000);
    },
    //上线
    connection() {
      //建立连接对象
      let baseUrl = process.env.VUE_APP_BASE_URL;
      //建立连接对象
      let socket = new SockJS("/api/message/ws");
      // debugger
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(socket);
      //将socket对象存在session里
      // sessionStorage.setItem("stompClient", this.stompClient);
      this.stompClient.debug = null
      // 定义客户端的认证信息,按需求配置
      let headers = {
        'Authorization': 'Bearer ' + this.accessToken
      };
      // 向服务器发起websocket连接
      this.stompClient.connect(headers, () => {
        console.log("连接websocket成功")
        this.stompClient.subscribe('/user/' + this.memberInfo.id + '/message', (msg) => {
          // msg.body存放的是服务端发送给我们的信息
          console.log('广播成功', msg.body)
          console.log(this.$route.path)
          if (this.$route.path != '/index') {
            this.$notify.info({
              title: '消息',
              message: '您有新的消息，请注意查收'
            });
          }
          this.resetSetItem('sockedMsgContent', msg.body);
        }, headers);
      }, (err) => {
        // 连接发生错误时的处理函数
        console.log('失败')
        console.log(err);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
  .out-menu{
    width: 245px;
    height: calc(100vh - 50px);
    overflow-x: hidden;
    overflow-y: auto ;
  }
  .inner-menu {
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100%;
  }
  .inner-menu::-webkit-scrollbar {
      display: none;
  }
  .home_shousuo {
    width: 64px;
    padding: 10px 0;
    text-align: center;
    cursor: pointer;
  }
</style>
